import type { AnalyticsPluginOptions } from '@atlaskit/editor-plugin-analytics';

interface Props {
	options: never;
}

export function analyticsPluginOptions({}: Props): AnalyticsPluginOptions {
	return {};
}
